module.exports = __webpack_public_path__ + "img/regular_lease_structure_infogp.04509fa2.png";